import { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Spacer } from '@zillow/constellation';
import { Button, FormField, Input, Label, Text } from '@zillow/constellation-10';

import { RMWContext } from '../../../../../providers/RMWContext';

import { PropertiesSelectors } from '../../../../../selectors';
import { useSelector } from '../../../../../selectors/useSelector';

import PostingActions from '../../../../../actions/PostingActions';

import type { ChangeEvent } from 'react';

const { property } = PostingActions;

type Props = {
  isSubmitDisabled?: boolean;
  onStartSubmit?: () => void;
};

const DeleteButton = ({ isSubmitDisabled, onStartSubmit }: Props) => {
  const dispatch = useDispatch();

  const { paths } = useContext(RMWContext);

  const { listingAlias } = useSelector((state) => PropertiesSelectors.makeCurrentProperty(state));

  const [deletePropertyReason, setDeletePropertyReason] = useState('');

  const handleDeletePropertySubmit = () => {
    // eslint-disable-next-line no-alert
    if (window.confirm(`Are you sure you want to permanently delete that listing?`)) {
      onStartSubmit && onStartSubmit();
      dispatch(property.delete(listingAlias, deletePropertyReason))
        // @ts-expect-error
        .then(() => window.router.updateLocation(paths.propertiesPage));
    }
  };

  return (
    <div data-testid="DeleteButton">
      <Text textStyle="body-sm-bold">Need to permanently delete this listing?</Text>

      <FormField css={{ marginBlock: '300' }}>
        <Label>Reason for deletion</Label>

        <Input onChange={(e: ChangeEvent<HTMLInputElement>) => setDeletePropertyReason(e.target.value)} />
      </FormField>

      <Spacer paddingY="xs">
        <Button
          tone="brand"
          emphasis="outlined"
          onClick={handleDeletePropertySubmit}
          disabled={isSubmitDisabled || deletePropertyReason === ''}
          fluid
        >
          Delete property
        </Button>
      </Spacer>
    </div>
  );
};

export default DeleteButton;
